import RetailerTypesService from "../../services/RetailerTypesService";

const state = {
    data: [],
    loaded: false,
}

const mutations = {
	SET_RETAILER_TYPES(state, types) {
        state.data = types;
        state.loaded = true;
    },
}

const actions = {
    load({commit}) {
        if (! state.loaded) {
            RetailerTypesService.all().then( ({data}) => commit('SET_RETAILER_TYPES', data));   
        }
    },
    refresh({commit}) {
        RetailerTypesService.all().then( ({data}) => commit('SET_RETAILER_TYPES', data));   
    }
}

const getters = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};